import {AfterViewInit, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {FabricProfile} from "../../product-details/interface/fabric-profile";
import {FabricProfileItemList} from "../../product-details/interface/fabric-profile-item-list";
import {PipeModule} from "../../pipe/pipe.module";
import {
	ProductCustomFabricProfileDialogComponent
} from "../product-custom-fabric-profile-dialog/product-custom-fabric-profile-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {log} from "console";

@Component({
	selector: 'fb-product-custom-fabric-profile',
	standalone: true,
	imports: [CommonModule, PipeModule],
	templateUrl: './product-custom-fabric-profile.component.html',
	styleUrls: ['./product-custom-fabric-profile.component.scss']
})
export class ProductCustomFabricProfileComponent implements OnChanges {

	@Input()
	public product: Product = {} as Product;

	@Input()
	public fabricProfile: FabricProfile = {} as FabricProfile;

	@Input()
	public minOrderQuantity: number = 1;

	@Input()
	public preOrder: boolean = false;

	public viewableFabricList: FabricProfileItemList[] = [];
	public fabricList: FabricProfileItemList[] = [];
	public selectedFabric: FabricProfileItemList | undefined = undefined;
	@Output()
	public fabricSelected: EventEmitter<FabricProfileItemList | undefined> = new EventEmitter<FabricProfileItemList | undefined>();

	constructor(
		private _dialog: MatDialog
	) {
	}
	ngOnChanges(): void {
		if(this.fabricProfile.fabricProfileItemList) {
			this.fabricList = this.fabricProfile.fabricProfileItemList;
			if(!this.preOrder){
				this.fabricList = this.fabricProfile.fabricProfileItemList.filter(fabricItem => fabricItem.fabricPreview.totalQuantity > this.minOrderQuantity);
			}
			if (this.fabricProfile.fabricProfileItemList.length > 3)
				this.viewableFabricList = this.fabricList.slice(0, 2);
			else {
				this.viewableFabricList = this.fabricList;
			}
		}
	}

	public extractGSM(productName: string): number | null {
		const regex = /(\d+)\s*GSM/i;
		const match = productName.match(regex);
		return match ? parseInt(match[1], 10) : null;
	}

	public selectFabric(fabric: FabricProfileItemList | undefined) {
		this.selectedFabric = fabric;
		const dialogRef = this._dialog.open(
			ProductCustomFabricProfileDialogComponent, {
				id: 'product-custom-fabric-profile-dialog',
				data: {
					fabricProfileItemList: this.fabricList,
					madeToOrderFabric: this.product.madeToOrderFabric,
					selectedFabric: this.selectedFabric
				},
				width: '100vw',
				maxWidth: '800px',
				height: '100%',
				position: {
					top: '0',
					right: '0'
				}
			});

		dialogRef.afterClosed().subscribe((selectedFabric: FabricProfileItemList | undefined) => {
			this.fabricSelected.emit(selectedFabric);
			this.selectedFabric = selectedFabric;

			if(this.selectedFabric) {
				const index = this.fabricList.findIndex(fabric => fabric.id === this.selectedFabric?.id);
				if (index !== -1) {
					this.fabricList.unshift(...this.fabricList.splice(index, 1));
					if(this.fabricList.length > 3)
					{
						this.viewableFabricList = this.fabricList.slice(0,2);
					}
					else {
						this.viewableFabricList = this.fabricList;
					}
				}
			}
		});
	}
}
